import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OibCheckerService {
  
    constructor() { }
  
    checkOIB(oib: string) {
      if (oib.replace(/-/g, '').match(/\d{11}/) === null || oib.length !== 11) {
        return;
      }
  
      let calculated = 10;
  
      for (const digit of oib.substring(0, 10)) {
        calculated += parseInt(digit);
        calculated %= 10;
  
        calculated === 0 && (calculated = 10);
        
        calculated *= 2;
        calculated %= 11;
      }
  
      let check = 11 - calculated;
  
      check === 10 && (check = 0);
  
      return check === parseInt(oib.charAt(10)) ? "valid" : "invalid";
    }
}